<template>
  <v-container fluid text-xs-center>
    <v-progress-linear :active="loading" height="3"  class="my-0" :indeterminate="true"></v-progress-linear>
    <v-layout row py-0>
      <v-spacer></v-spacer>
        <v-btn icon :disabled="loading" @click="getRanking()">
          <v-icon class="text--secondary">refresh</v-icon>
        </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md3>
        <img
          v-if="leftSideAd"
          :src="imageUrl + leftSideAd.img"
          :width="leftSideAd.width"
          :height="leftSideAd.height"
          style="max-width: 100%"
          alt
        >
      </v-flex>
      <v-flex xs12 md6 py-3>
        <v-radio-group
          v-if="tournament.type == 'usersTeams'"
          v-model="rankingByTeams"
          @change="getRanking"
          row
          :disabled="loading"
        >
          <v-radio :label="$t('byUsers')" :value="false" color="primary"></v-radio>
          <v-radio :label="$t('byTeams')" :value="true" color="primary"></v-radio>
        </v-radio-group>
        <v-data-table
          :headers="headers"
          :items="rankingList"
          :loading="loading"
          :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
          class="elevation-1"
          item-key="name"
        >
          <template slot="items" slot-scope="props">
            <td>{{props.item.position}}</td>
            <td>{{props.item.participant}}</td>
            <td>{{props.item.entity}}</td>
            <td>{{props.item.points}}</td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 md3 >
        <img
          v-if="rightSideAd"
          :src="imageUrl + rightSideAd.img"
          :width="rightSideAd.width"
          :height="rightSideAd.height"
          style="max-width: 100%"
          alt
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'tabClasificacion',
  data () {
    return {
      loading: false,
      rankingByTeams: false,
      imageUrl: process.env.VUE_APP_IMAGE_URL

    }
  },
  methods: {
    ...mapActions({
      setRanking: 'matches/setRanking',
      getOneTournament: 'tournaments/setOne',
    }),
    getRanking () {
      this.getOneTournament(this.tournament._id)
      let params = { tournamentId: this.tournament._id }
      if (this.rankingByTeams) {
        params.rankingByTeams = true
      }
      this.loading = true
      this.setRanking(params)
        .catch((err) =>
          this.rankingByTeams = !this.rankingByTeams
        )
        .finally(_ => this.loading = false)
    },
    formatEntity (participantId) {
      if (this.tournament.type == 'teams' || this.rankingByTeams) {
        let team = this.tournament.teams.find(team => team.teamId === participantId)
        if (team && team.entity) return team.entity
      } else if (this.tournament.type == 'usersTeams') {
        let team = this.tournament.teams.find(team => team.userIds.includes(participantId))
        if (team && team.entity) return team.entity
      } else if (this.tournament.type == 'users') {
        let user = this.tournament.users.find(user => user.userId === participantId)
        if (user && user.entity) return user.entity
      }
      return '*'
    },
    formatParticipant (participantId) {
      if (this.tournament.type == 'teams' || this.rankingByTeams) {
        let team = this.tournament.teams.find(team => team.teamId === participantId)
        if (team && team.name) return team.name
      } else {
        let user = this.tournament.users.find(user => user.userId === participantId)
        if (user && user.name) return user.name
      }
      return '*'
    }
  },
  computed: {
    ...mapState({
      tournament: state => state.tournaments.selected,
      listSelectTeams: state => state.teams.listSelectTeams,
      listSelectUsers: state => state.users.listSelectUsers,
      ranking: state => state.matches.ranking,
      listAds: state => state.advertising.list
    }),
    headers () {
      return [
        {
          text: this.$t('position').toUpperCase(),
          value: 'position',
          align: 'center'
        },
        {
          text: (this.tournament.type == 'teams' || this.rankingByTeams ? this.$tc('team') : this.$tc('user')).toUpperCase(),
          value: 'team',
          align: 'center'
        },
        {
          text: this.$tc('entity').toUpperCase(),
          value: 'entity',
          align: 'center'
        },
        {
          text: this.$t('points').toUpperCase(),
          value: 'points',
          align: 'center'
        }

      ]
    },
    rankingList () {
      return this.ranking.map((item, index) => {
        return {
          position: index + 1,
          participant: this.formatParticipant(item.objectId),
          entity: this.formatEntity(item.objectId),
          points: item.points
        }
      })
    },
    leftSideAd () {
      if (this.tournament && this.tournament._id) {
        let filteredAds = this.listAds.filter(ad => ad.active && ad.tournamentId == this.tournament._id && ad.location == 'leftRankingTournament')
        return filteredAds.length ? filteredAds[0] : null
      } else return null
    },
    rightSideAd () {
      if (this.tournament && this.tournament._id) {
        let filteredAds = this.listAds.filter(ad => ad.active && ad.tournamentId == this.tournament._id && ad.location == 'rightRankingTournament')
        return filteredAds.length ? filteredAds[0] : null
      } else return null
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  max-width: none !important;
  padding-left: 0;
  padding-right: 0;
}
</style>
